import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  loaderAllEmployees: false,
  saveLoading: false,
  employees:[],
  employeesLength: 0,
  employee: {},
  employeesFaild: null
}

export default function employeesReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EMPLOYEES:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADING_EMPLOYEES:
      return {...state, saveLoading: action.payload}
    case actions.LOADER_ALL_EMPLOYEES:
      return {...state, loaderAllEmployees: action.payload}
    case actions.GET_EMPLOYEE:
      return {...state, employee: action.payload}
    case actions.GET_EMPLOYEES:
      return {...state, employees: action.payload.employees, employeesLength: action.payload.employeesLength}
    case actions.GET_ALL_EMPLOYEES_FAILD:
      return {...state, employeesFaild: action.payload}
    default:
      return state
  }
}